import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface EmptyStateProps {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly body?: ReactNode;
  readonly action?: ReactNode;
  readonly className?: string;
}

/** Empty state - used when a list, search result, or page has no
 *  rows to show. The action slot lets the parent surface a CTA
 *  ("New sale", "Open a session", etc.). */
export function EmptyState({ icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-line bg-surface-muted/40 px-6 py-12 text-center",
        className,
      )}
    >
      {icon && <div className="text-faint">{icon}</div>}
      <div>
        <h3 className="text-sm font-semibold text-strong">{title}</h3>
        {body && <p className="mx-auto mt-1 max-w-sm text-sm text-muted">{body}</p>}
      </div>
      {action}
    </div>
  );
}
